import { AuthUser } from 'aws-amplify/auth';
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PathRoutes } from 'src/const/Routes/PathRoutes';

interface ProtectedRouteProps {
  user: AuthUser | null;
}

/**
 * Where a logged-out visitor goes: the login page, which brings them back to
 * the address they opened (path and query, for example a circle's 360 tab
 * from a 360review email) once they have logged in. The login page already
 * reads `redirectUrl`.
 */
export const loginRouteFor = (pathname: string, search: string): string => {
  const intended = `${pathname}${search}`;
  if (!pathname || pathname === PathRoutes.RootRoute) {
    return PathRoutes.RootRoute;
  }
  return `${PathRoutes.LoginRoute}?redirectUrl=${encodeURIComponent(intended)}`;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ user }) => {
  const { pathname, search } = useLocation();
  return user ? <Outlet /> : <Navigate to={loginRouteFor(pathname, search)} />;
};

export default ProtectedRoute;
